export default __webpack_public_path__ + "static/media/stewardship-blue.fd1c3eb0.svg";